import { create } from "zustand";

export interface PropertiesPanelState {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

export const usePropertiesPanelStore = create<PropertiesPanelState>()(
    (set) => ({
        isOpen: false,

        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
    })
);
